exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".score[data-v-6148394d]{margin-bottom:9px}@media only screen and (min-width:500px){.score[data-v-6148394d]{margin-bottom:30px}}.score__title[data-v-6148394d]{font-weight:unset;font-size:18px;line-height:1.2;text-transform:uppercase;letter-spacing:.03em;color:rgba(0,0,0,.6);margin-bottom:12px}.score__info[data-v-6148394d]{display:-ms-grid;display:grid}@media only screen and (min-width:500px){.score__info[data-v-6148394d]{width:100%;-ms-grid-columns:(1fr)[4];grid-template-columns:repeat(4,1fr)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6148394d","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/certificate/components/score/Score.vue
// module id = 7c66f090e1b3c23f4ce0
// module chunks = 9